import { render, staticRenderFns } from "./DenomSummary.vue?vue&type=template&id=3f7472a9"
import script from "./DenomSummary.vue?vue&type=script&lang=js"
export * from "./DenomSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports